/**
 * Created by Abner Sui on 09/27/2019
 * -------------------------------------
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../../widgets/widgets.module';
import { PopupModule } from '@progress/kendo-angular-popup';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { WorkflowTriggerSettingsComponent } from './workflow-trigger-settings.component';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { NoteDepositTriggerComponent } from './note-deposit-trigger/note-deposit-trigger.component';
import { NoteDepositTriggerFilterDialogComponent } from './note-deposit-trigger/note-deposit-trigger-filter-dialog.component';
import { NoteDepositTiggerFilterDialogService } from './note-deposit-trigger/note-deposit-trigger-filter-dialog.service';
import { NoteDepositTriggerMetaDialogComponent } from './note-deposit-trigger/note-deposit-trigger-meta-dialog.component';
import { NoteDepositTriggerMetaDialogService } from './note-deposit-trigger/note-deposit-trigger-meta-dialog.service';

@NgModule({
    imports: [
        ButtonsModule,
        CommonModule,
        DateInputsModule,
        DropDownsModule,
        PopupModule,
        TooltipModule,
        WidgetsModule,
    ],
    declarations: [
        WorkflowTriggerSettingsComponent,
        NoteDepositTriggerComponent,
        NoteDepositTriggerFilterDialogComponent,
        NoteDepositTriggerMetaDialogComponent
    ],
    exports: [
        WorkflowTriggerSettingsComponent,
    ],
    providers: [NoteDepositTiggerFilterDialogService, NoteDepositTriggerMetaDialogService]
})
export class WorkflowTriggerSettingsModule { }
